import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { EnumWidgetId } from './@types/Widget';
import ScrollToTop from './routes/RoutesScrollToTop';
import ViewContact from './views/generic/ViewContact';
import ViewHome from './views/generic/ViewHome';
import ViewAustralianBusinessNumberGenerator from './views/widgets/ViewAustralianBusinessNumberGenerator';
import ViewAustralianBusinessNumberValidator from './views/widgets/ViewAustralianBusinessNumberValidator';
import ViewAustralianCompanyNumberGenerator from './views/widgets/ViewAustralianCompanyNumberGenerator';
import ViewAustralianCompanyNumberValidator from './views/widgets/ViewAustralianCompanyNumberValidator';
import ViewAustralianTaxFileNumberGenerator from './views/widgets/ViewAustralianTaxFileNumberGenerator';
import ViewAustralianTaxFileNumberValidator from './views/widgets/ViewAustralianTaxFileNumberValidator';
import ViewNewZealandIRDGenerator from './views/widgets/ViewNewZealandIRDGenerator';
import ViewNewZealandIRDValidator from './views/widgets/ViewNewZealandIRDValidator';
import ViewNewZealandIRDV2Generator from './views/widgets/ViewNewZealandIRDV2Generator';
import ViewNewZealandIRDV2Validator from './views/widgets/ViewNewZealandIRDV2Validator';
import ViewAustralianMedicareNumberGenerator from './views/widgets/ViewAustralianMedicareNumberGenerator';
import ViewAustralianMedicareNumberValidator from './views/widgets/ViewAustralianMedicareNumberValidator';
import ViewNewZealandBankAccountValidator from './views/widgets/ViewNewZealandBankAccountValidator';
import ViewNewZealandBusinessNumberGenerator from './views/widgets/ViewNewZealandBusinessNumberGenerator';
import ViewNewZealandBusinessNumberValidator from './views/widgets/ViewNewZealandBusinessNumberValidator';
import ViewAustralianBsbValidator from './views/widgets/ViewAustralianBsbValidator';
import ViewIbanValidator from './views/widgets/ViewIbanValidator';
import ViewWidgetsList from './views/widgets/ViewWidgetsList';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
        <Routes>
          <Route path="/">
            <Route index element={<ViewHome />} />
            <Route path="contact" element={<ViewContact />} />
            <Route path="widgets">
              <Route path={`${EnumWidgetId.AUSTRALIAN_COMPANY_NUMBER_GENERATOR}/*`} element={<ViewAustralianCompanyNumberGenerator />} />
              <Route path={`${EnumWidgetId.AUSTRALIAN_COMPANY_NUMBER_VALIDATOR}/*`} element={<ViewAustralianCompanyNumberValidator />} />
              <Route path={`${EnumWidgetId.AUSTRALIAN_TAX_FILE_NUMBER_GENERATOR}/*`} element={<ViewAustralianTaxFileNumberGenerator />} />
              <Route path={`${EnumWidgetId.AUSTRALIAN_TAX_FILE_NUMBER_VALIDATOR}/*`} element={<ViewAustralianTaxFileNumberValidator />} />
              <Route path={`${EnumWidgetId.NEW_ZEALAND_IRD_GENERATOR}/*`} element={<ViewNewZealandIRDGenerator />} />
              <Route path={`${EnumWidgetId.NEW_ZEALAND_IRD_VALIDATOR}/*`} element={<ViewNewZealandIRDValidator />} />
              <Route path={`${EnumWidgetId.NEW_ZEALAND_IRD_V2_GENERATOR}/*`} element={<ViewNewZealandIRDV2Generator />} />
              <Route path={`${EnumWidgetId.NEW_ZEALAND_IRD_V2_VALIDATOR}/*`} element={<ViewNewZealandIRDV2Validator />} />
              <Route path={`${EnumWidgetId.AUSTRALIAN_BUSINESS_NUMBER_GENERATOR}/*`} element={<ViewAustralianBusinessNumberGenerator />} />
              <Route path={`${EnumWidgetId.AUSTRALIAN_BUSINESS_NUMBER_VALIDATOR}/*`} element={<ViewAustralianBusinessNumberValidator />} />
              <Route path={`${EnumWidgetId.AUSTRALIAN_MEDICARE_NUMBER_GENERATOR}/*`} element={<ViewAustralianMedicareNumberGenerator />} />
              <Route path={`${EnumWidgetId.AUSTRALIAN_MEDICARE_NUMBER_VALIDATOR}/*`} element={<ViewAustralianMedicareNumberValidator />} />
              <Route path={`${EnumWidgetId.NEW_ZEALAND_BANK_ACCOUNT_VALIDATOR}/*`} element={<ViewNewZealandBankAccountValidator />} />
              <Route path={`${EnumWidgetId.NEW_ZEALAND_BUSINESS_NUMBER_GENERATOR}/*`} element={<ViewNewZealandBusinessNumberGenerator />} />
              <Route path={`${EnumWidgetId.NEW_ZEALAND_BUSINESS_NUMBER_VALIDATOR}/*`} element={<ViewNewZealandBusinessNumberValidator />} />
              <Route path={`${EnumWidgetId.AUSTRALIAN_BSB_VALIDATOR}/*`} element={<ViewAustralianBsbValidator />} />
              <Route path={`${EnumWidgetId.IBAN_VALIDATOR}/*`} element={<ViewIbanValidator />} />
              <Route path={``} element={<ViewWidgetsList />} />
            </Route>
          </Route>
        </Routes>
    </BrowserRouter>
  );
}

export default App;